var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasicInfoEdit = function SvgBasicInfoEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.835 6.436 1.656-2.414a1.583 1.583 0 0 0-.441-2.208L9.75.269A1.636 1.636 0 0 0 7.51.697L5.892 3.075l4.943 3.36ZM8.83 1.204a.39.39 0 0 1 .215.066l2.318 1.527a.381.381 0 0 1 .11.537l-.963 1.418-2.937-1.991.95-1.4a.388.388 0 0 1 .307-.157Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.256 16a.909.909 0 0 0 .276-.042l2.735-.718a1.803 1.803 0 0 0 1.061-.73l2.11-3.09a.596.596 0 0 0-.141-.869.621.621 0 0 0-.853.163l-2.103 3.077a.781.781 0 0 1-.264.23h-.08l-2.453.664L1.2 12.09s.056-.127.16-.272l5.526-8.043 2.938 1.991-1.3 1.877a.596.596 0 0 0 .165.838.621.621 0 0 0 .852-.163l1.975-2.884-4.961-3.367-6.213 9.094a1.675 1.675 0 0 0-.325 1.249l.355 2.83a.85.85 0 0 0 .38.603.893.893 0 0 0 .504.157Z"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 11.846 0)",
    x: 0.556,
    y: 14.793,
    width: 10.733,
    height: 1.207,
    rx: 0.603
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 27.86 0)",
    x: 11.86,
    y: 14.793,
    width: 4.14,
    height: 1.207,
    rx: 0.603
  }))));
};
export default SvgBasicInfoEdit;